export enum RelatedTaskDeadline {
  Undefined = 0,
  Before = 10,
  After = 20,
  On_Cancelled = 30,
}
